module.exports = __webpack_public_path__ + "components/login/static/snow-forecast__logo-00e99013c762ebedd02a29259d56f851.svg";